<template>
  <d-navbar-nav class="flex-row">
<!--  <d-navbar-nav class="border-left flex-row">-->
<!--    <li class="nav-item border-right dropdown notifications">-->
<!--      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>-->
<!--        <div class="nav-link-icon__wrapper">-->
<!--          <i class="material-icons">&#xE7F4;</i>-->
<!--          <d-badge pill theme="danger">2</d-badge>-->
<!--        </div>-->
<!--      </a>-->
<!--      <d-collapse id="notifications" class="dropdown-menu dropdown-menu-small">-->
<!--        <d-dropdown-item>-->
<!--          <div class="notification__icon-wrapper">-->
<!--            <div class="notification__icon">-->
<!--              <i class="material-icons">&#xE6E1;</i>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="notification__content">-->
<!--            <span class="notification__category">Analytics</span>-->
<!--            <p>Your website’s active users count increased by <span class="text-success text-semibold">28%</span> in the last week. Great job!</p>-->
<!--          </div>-->
<!--        </d-dropdown-item>-->
<!--        <d-dropdown-item href="#">-->
<!--          <div class="notification__icon-wrapper">-->
<!--            <div class="notification__icon">-->
<!--              <i class="material-icons">&#xE8D1;</i>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="notification__content">-->
<!--            <span class="notification__category">Sales</span>-->
<!--            <p>Last week your store’s sales count decreased by <span class="text-danger text-semibold">5.52%</span>. It could have been worse!</p>-->
<!--          </div>-->
<!--        </d-dropdown-item>-->
<!--        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>-->
<!--      </d-collapse>-->
<!--    </li>-->
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
        <img class="user-avatar rounded-circle mr-2" src="@/assets/images/avatars/user.png" alt="User Avatar">
        <span class="d-none d-md-inline-block">
          {{auth.name}} ({{auth.roleName}})
        </span>
      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item class="text-danger" @click.native="onLogoutClick" :disabled="fetchingLogout">
          <i v-if="fetchingLogout"><b-spinner small></b-spinner></i>
          <i v-else class="material-icons text-danger">&#xE879;</i>
          Déconnexion
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import {Api, Toast} from "@/helpers"

  export default {
    data() {
      return {
        fetchingLogout: false
      }
    },
    methods: {
      onLogoutClick(e) {
        e.preventDefault()
        const toast = Toast.loading("Déconnexion...")
        this.fetchingLogout = true
        Api.post('/auth/logout')
          .then(res => {
            if (res.status === 'success' && res.data)
              this.logout()
            else
              this.error = res
          })
          .catch(e => this.error = e)
          .then(() => {
            this.fetchingLogout = false
            toast.goAway()
          })
      },
    }
  }
</script>

<style>
  .nav-link:hover {
    cursor: pointer;
  }
</style>
